// react
import React, { useRef, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// hooks
import useNotifications from '../../hooks/useNotifications';
// styles
import { Button, Container, Form, Row, Col, Image } from 'react-bootstrap';
import { Facebook } from 'react-bootstrap-icons';
import styles from './Register.module.css';
import googleLogo from '../../../app/assets/btn_google.svg';
import { useAnalytics, usePageView } from '../../hooks/useAnalytics';
import { AppContext, AccountContext } from '../../GlobalContex';

const Register = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const { setIsLoading } = useContext(AppContext);
  usePageView('Register');

  const navigate = useNavigate();
  const location = useLocation();

  const email = useRef(null);
  const password = useRef(null);

  const [formStage, setFormStage] = useState('login');

  const { sendEvent } = useAnalytics();

  let { from } = location.state || { from: '/home' };

  const { signinUsingSocialAuth, signup, signin } = useContext(AccountContext);

  const submitHandler = async e => {
    e.preventDefault();
    if (formStage === 'login') {
      try {
        await signup(email.current.value);
        notification.success(
          `Electric Blaze Account Created! Check your email. Your account password is sent to ${email.current.value}. If you haven't received the email, please check Spam folder`
        );
      } catch (err) {
        console.log(err.message);
        if (err.code === 'UserAlreadyExists') {
          navigate(`/login/${email.current.value}`);
          return;
        }
      }
    }

    setFormStage('password');
    if (!password.current.value) return;
    if (formStage === 'password') {
      try {
        await signin(email.current.value, password.current.value);
        sendEvent('login', {
          method: 'Email'
        });
      } catch (err) {
        notification.warning(err.message);
        return;
      }
    }
    navigate('/home');
  };

  async function signinWithService(service) {
    setIsLoading(true);
    try {
      await signinUsingSocialAuth(service.toLowerCase());
      sendEvent('login', { method: service });
      setIsLoading(false);
      navigate(from);
    } catch (err) {
      notification.warning(err.message);
      setIsLoading(false);
    }
  }

  return (
    <div className={"d-flex flex-column justify-content-center bootstrap-app-styles h-100"}>
      <div className={'d-flex'}>
        <Container>
          <Row className="justify-content-center">
            <Col xs={12}>
              <Form onSubmit={e => submitHandler(e)}>
                <h5 className="text-center mb-3">{t('Login/Sign up')}</h5>
               <Row className="form-group mb-3 g-3">
                  <Col>
                    <Button
                      className={'w-100 shadow ' + styles.google__btn}
                      variant="white"
                      onClick={() => signinWithService('Google')}>
                      <img
                        width="24"
                        height="24"
                        src={googleLogo}
                        alt="google logo"
                        className="me-3"
                      />
                      Google
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      className={'w-100 shadow ' + styles.facebook__btn}
                      onClick={() => signinWithService('Facebook')}>
                      <Facebook size={24} className="me-3" />
                      Facebook
                    </Button>
                  </Col>
                </Row>
                <h5 className="text-center mb-3">or with email</h5>
                <Form.Group controlId="loginFormEmail" className="mb-3">
                  <Form.Control type="email" placeholder={t('Enter Email')} ref={email} />
                </Form.Group>
                {formStage === 'password' ? (
                  <Form.Group controlId="loginFormPassword" className="mb-3">
                    <Form.Control type="password" placeholder={t('Password')} ref={password} />
                  </Form.Group>
                ) : (
                  ''
                )}
                <Button type="submit" className="w-100 mb-1">
                  {t('Next')}
                </Button>
                {formStage === 'password' && <a className="form-text link-primary" href="" onClick={(e) => {
                  e.preventDefault();
                  navigate('/forgot-password')
                }}>
                  {t('Forgot Password?')}
                </a>}
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={'d-flex position-absolute bottom-0 w-100 pb-2 text-center'}>
        <Container>
          <Row>
            <Col>
              <a href="https://electricblaze.com/privacy.html" className="text-primary">Privacy Policy</a>
              <span className={'p-2'} style={{color: '#ced4da'}}>|</span>
              <a href="https://electricblaze.com/tos.html" className="text-primary">Terms of Service</a>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Register;
